import React, { useState } from "react";
import cn from "classnames";
import styles from "./List.module.sass";
import Card from "../../../components/Card";
import Actions from "../../../components/Actions";
import Loader from "../../../components/Loader";
import Item from "./Item";
import { markAllNotificationsAsRead } from "../../../services/notification.service";
import { showSuccess, showError } from "../../../services/toast.service";
import eventEmitter from "../../../services/event.service";

const List = ({ 
  className, 
  notifications = [], 
  loading = false, 
  selectedNotifications = [], 
  onSelect 
}) => {
 
  
  const handleMarkAllAsRead = async () => {
    try {
      await markAllNotificationsAsRead();
      showSuccess("Toutes les notifications ont été marquées comme lues");
      eventEmitter.dispatch('notificationsUpdated');
    } catch (error) {
      showError(`Erreur lors du marquage des notifications: ${error.message}`);
    }
  };
  
  const actions = [
    {
      title: "Marquer comme lues",
      icon: "check",
      action: handleMarkAllAsRead,
    }
  ];

  return (
    <Card
      className={cn(styles.card, className)}
      title="Notifications"
      classTitle={cn("title-red", styles.title)}
      classCardHead={styles.head}
      head={
        <>
          <Actions
            className={styles.actions}
            classActionsHead={styles.actionsHead}
            items={actions}
          />
        </>
      }
    >
      <div className={styles.notifications}>
        {loading ? (
          <Loader />
        ) : notifications.length === 0 ? (
          <div className={styles.empty}>
            <p>Aucune notification disponible.</p>
          </div>
        ) : (
          <div className={styles.list}>
            {notifications.map((notification, index) => (
              <Item 
                className={cn(styles.item, className)} 
                item={notification} 
                key={notification.id || index}
                selected={selectedNotifications.includes(notification.id)}
                onSelect={onSelect}
              />
            ))}
          </div>
        )}
      </div>
    </Card>
  );
};

export default List;
